import { render, staticRenderFns } from "./case_document.vue?vue&type=template&id=289bf3b5&"
import script from "./case_document.vue?vue&type=script&lang=js&"
export * from "./case_document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports